import NoteConnected from './NoteConnected'
export default NoteConnected
